import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  selectRoleList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/role/page',
      method: 'post',
      data:param
    })
  },
  del(param) {
	return request({
		url: store.getters.getPostUrl + 'mes/role',
		method: 'delete',
		params:{'id': param}
	})
  },
  selectRole() {
	return request({
		url: store.getters.getPostUrl + 'mes/role/all',
		method: 'get'
	})
  },
  insert(param) {
	return request({
		url: store.getters.getPostUrl + 'mes/role/insert',
		method: 'post',
		data:param
	})
  },
  update(param) {
  	return request({
  		url: store.getters.getPostUrl + 'mes/role/update',
  		method: 'post',
  		data:param
  	})
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/role/role.js